import { AdminMessagesScreen } from '@/screens/admin/admin-messages-screen'

export default function () {
  return <AdminMessagesScreen />
}
